// media-library-preview.component.ts
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MediaLibraryFileModel } from 'src/app/models/sales-funnel';

@Component({
  selector: 'app-media-library-preview',
  templateUrl: './media-library-preview.component.html',
  styleUrl: './media-library-preview.component.css',
})
export class MediaLibraryPreviewComponent {
  videoType: 'url' | 'file' = 'url';
  @Input()iframeLoaded: boolean = false;
  @Output() iframeLoadedChange: EventEmitter<any> = new EventEmitter<any>();


  videoPreviewUrl: SafeResourceUrl;

  @Input('url') set url(value: string) {
    this.videoPreviewUrl = value;
  }
  @Input('file') set file(value: MediaLibraryFileModel) {
    this.videoPreviewUrl = value?.video?.url;
  }

  constructor(
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    
  }

  frameLoaded() {
    this.iframeLoaded = true;
    this.iframeLoadedChange.emit()
  }
}
